
	$(document).ready(function() {

        $(window).resize(function () {
            jQuery('#social_form .box').each(function() {
                if (window.innerWidth < 600) {
                return jQuery(this).css('width', 'calc( 100% / '+social_length.length / 6+' )' );
                }
                jQuery(this).css('width', 'calc( 100% / '+social_length.length / 2+' )' );
            });
        })

    if(jQuery('#socialMedia').length > 0){

		var social_length = [];
		jQuery('#social_form .box').each(function() {
			if (jQuery(this).css('display') != "none"){
				social_length.push("0");
			}
		});

		jQuery('#social_form .box').each(function() {
            if (window.innerWidth < 600) {
			return jQuery(this).css('width', 'calc( 100% / '+social_length.length / 6+' )' );
            }
			jQuery(this).css('width', 'calc( 100% / '+social_length.length / 2+' )' );
		});

		//custom links

		jQuery('#social_form').on('click','.remove-custom-link', function(e){
			e.preventDefault();
			var go = jQuery(this).attr('href');
			if(confirm("This link will be removed from your profile. Continue?")) {
				window.location = go;
			}
		});

        function filterCustomLinks() {
            let socialSelectorImages = jQuery('.socials-selector').find('img');
            let socialLinksInputs = jQuery('#social_form #sortable').find('input');

            $.each(socialLinksInputs, function() {
                let needle = $(this).data('settings');

                if (needle !== undefined && needle.name !== undefined) {
                    $.each(socialSelectorImages, function () {
                        let settings = $(this).data('settings');
                        if (settings !== undefined && settings.name !== undefined && settings.name === needle.name) {
                            $(this).closest('.box').hide();
                        }
                    });
                }
            });
        }

		jQuery('#social_form').on('click','.add_custom_link', function(e){
            e.preventDefault();

			jQuery(this).hide()

            filterCustomLinks();

			jQuery('.socials-selector, .add_custom_link_other, .cancel_custom_link').show();
		});

		jQuery('#social_form').on('click','.cancel_custom_link', function(e){
			e.preventDefault();
			jQuery('.add_custom_link').show()
			jQuery('.socials-selector, .add_custom_link_other, .cancel_custom_link').hide();
		});

		jQuery('#social_form').on('click','.box', function(e){
			e.preventDefault();
			jQuery('.socials-selector, .add_custom_link_other, .cancel_custom_link').hide();
			jQuery('.add_custom_link').show();
            const counter = document.querySelectorAll('#sortable .custom-link').length;

            const dataSettings = jQuery(this).find('img').data('settings');
            const inputId = 'company_search_' + counter;
            const url = jQuery(this).find('img').attr('alt');
            let inputValue = '';

            if (dataSettings && dataSettings.search) {
                inputValue = '';
            } else {
                inputValue = url;
            }

            // redirect selector — both legacy (5) and any-rating (8) weighted modes show weight inputs
            const redirectRuleValueWeight = [5, 8].includes(parseInt($("#redirectAlgorithm").val(), 10));

            let html = `
                <div class="d-flex flex-row public-link-wrapper">
                    <div class="${redirectRuleValueWeight ? 'd-block' : 'd-none'} weight-input">
                        <div class="d-flex flex-row align-items-center">
                            <input type="number" min="0" max="99" name="linksCustom[${counter}][weight]" class="form-control input-group" placeholder="0" value="0"><strong class="ml-1 mt-2">%</strong>
                        </div>
                    </div>
                    <div class="input-group mb-3 feedback-form-control mb-2 border custom-link" id="custom-${counter}">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <img class="custom_image" alt="" src="${jQuery(this).find('img').attr('src')}" width="13" height="13">
                            </div>
                        </div>
                        <input type="url" class="form-control" name="linksCustom[${counter}][url]" value="${inputValue}" aria-label="URL" required="required" placeholder="Search and add link" id="${inputId}" data-url="${url}" data-settings='${JSON.stringify(dataSettings)}'>
                        <div class="input-group-append">
                            <div class="input-group-text">
            `;

                    if (dataSettings.name && dataSettings.name === 'google') {
                        html += ` <a href="#" onclick="jQuery(${inputId}).trigger('focus')" title="Search for you page on ${dataSettings.name}">
                                        <i class="fas fa-search mr-2"></i>
                                     </a> `;
                        html += ` <input type="hidden" id="place_id" name="place_id" value="" > `;

                    } else {
                        html += ` <a href="${url}" target="_blank" title="Search for you page on ${dataSettings.name}">
                                        <i class="fas fa-search mr-2"></i>
                                     </a> `;
                    }

                    html += ` <a href="" class="remove-custom text-danger" data-remove-elem="custom-${counter}" title="${__('Remove')}">
                                <i class="fas fa-minus-circle mr-2"></i>
                            </a>
                            <input type="hidden" name="linksCustom[${counter}][logo]" value="${jQuery(this).find('img').data('logo')}" >
                            <input type="hidden" name="linksCustom[${counter}][settings]" value='${JSON.stringify(dataSettings)}'>
                            <input class="public-review-links-checkbox" aria-label="${__('Show in list')}" type="checkbox" name="linksCustom[${counter}][active]" title="${__('Show in list')}" checked="checked">
                        </div>
                    </div>
                </div>
                </div>
            `;
			jQuery('#social_form #sortable').append(html);
            $('body input').trigger('change');

            if (dataSettings.name && dataSettings.name === 'google') {
                initMap(inputId);
            }
		});

		jQuery('#social_form').on('click','.add_custom_link_other', function(e){
			e.preventDefault();
			jQuery('.socials-selector, .add_custom_link_other, .cancel_custom_link').hide();
			jQuery('.add_custom_link').show();
            window.after_changes += '';
            const counter = document.querySelectorAll('#sortable .custom-link').length;
            // redirect selector — both legacy (5) and any-rating (8) weighted modes show weight inputs
            const redirectRuleValueWeight = [5, 8].includes(parseInt($("#redirectAlgorithm").val(), 10));
			const html = `
                <div class="d-flex flex-row public-link-wrapper">
                    <div class="${redirectRuleValueWeight ? 'd-block' : 'd-none'} weight-input">
                        <div class="d-flex flex-row align-items-center">
                            <input type="number" min="0" max="99" name="linksCustom[${counter}][weight]" class="form-control input-group" placeholder="0" value="0"><strong class="ml-1 mt-2">%</strong>
                        </div>
                    </div>
                    <div class="input-group mb-3 feedback-form-control mb-2 border custom-link" id="custom-${counter}">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <i class="fas fa-cloud icon-logo-upload"></i>
                                <img class="custom-logo hidden" alt="brand-logo" width="13" height="13">
                                <input type="file" class="hidden" name="linksCustom[${counter}][upload]" id="custom_file">
                            </div>
                        </div>
                        <input type="url" class="form-control" name="linksCustom[${counter}][url]" aria-label="URL" required="required" placeholder="Type url">
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <a href="" class="upload-custom mr-2" data-placement="top" title="Upload logo">
                                    <i class="fas fa-upload"></i>
                                </a>
                                <a href="" class="remove-custom text-danger" data-remove-elem="custom-${counter}" title="${__('Remove')}">
                                    <i class="fas fa-minus-circle mr-2"></i>
                                </a>
                                <input type="hidden" name="linksCustom[${counter}][logo]">
                                <input type="hidden" name="linksCustom[${counter}][settings]">
                                <input class="public-review-links-checkbox" aria-label="${__('Show in list')}" type="checkbox" name="linksCustom[${counter}][active]" title="${__('Show in list')}" checked="checked">
                            </div>
                        </div>
                    </div>
                </div>
				`;
			jQuery('#social_form #sortable').append(html);
            $('body input').trigger('change');
		});

        jQuery('#social_form').on('click','.upload-custom', function(e){
            e.preventDefault();
            jQuery('#custom_file').click();
        });

		jQuery('#social_form').on('click','.social-display-checkbox input', function(e){
			var linktype = $(this).parent().attr("for");
			var text = "";
			if(linktype === "link_display_facebook"){
				text = $("#link_facebook").val();
			}
			else if(linktype === "link_display_google"){
				text = $("#link_google").val();
			}
			else if(linktype === "link_display_yelp"){
				text = $("#link_yelp").val();
			}
			else if(linktype.includes("brand_url_")) {
				var id = linktype.replace("brand_url_","").replace("_display","");
				text = $("[name=link_custom_"+id+"]").val();
			}
			else if(linktype.includes("display_custom_update_")) {
				var id = linktype.replace("display_custom_update_","");
				text = $("[name=update_custom_"+id+"]").val();
			}
			if(!text){
				$(this).prop("checked", false);
			}
		});

        // document.querySelector('#custom_file').addEventListener('change', function (e) {
        //     const customImage = document.querySelector('.custom-logo');
        //     console.log(customImage);
        // })

        jQuery('#social_form').on('change', '#custom_file', function () {
            const img = jQuery(this).closest('#sortable').find('.custom-logo');
            img.removeClass('hidden');
            document.querySelectorAll('.icon-logo-upload').forEach(function (e) {
                e.classList.add('hidden');
            })
            readURL(this, img);
        });

        function readURL(input, img) {
            if (input.files && input.files[0]) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    img.attr('src', e.target.result);
                }
                reader.readAsDataURL(input.files[0]);
            }
        }
    }
	});
